module.exports = __webpack_public_path__ + "static/media/user.e6aaf430.svg";